import { useContext } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import clsx from 'clsx';

import { ifTrue } from 'src/tools/logic.tools';

import { FormParserContext } from 'src/contexts/form.context';

import classes from './PhoneNumberInput.module.scss';

export function PhoneNumberInput() {
  const { value, onChange, onSubmit, script, error } = useContext(FormParserContext);

  function handleOnChange(newValue: string) {
    onChange(newValue);
  }

  return (
    <PhoneInput
      international
      className={clsx(classes.container, ifTrue(error, 'with-error'))}
      value={value}
      onChange={handleOnChange}
      onSubmit={onSubmit}
      placeholder={script.placeholder}
      type='tel'
    />
  );
}
